import React from 'react';
import { Flex } from '@chakra-ui/react';
import { useGameColorsProvider } from '../../providers/Theme/gameColorsProvider';
import { Color } from 'src/theme/color';

export const CoverBackground = ({
	children,
	color = Color.ACTION,
	coverPhoto,
	isNonGradient = false,
}: {
	color?: string;
	coverPhoto?: string;
	children: any;
	isNonGradient?: boolean;
}) => {
	const { backgroundColor, callToActionColor } = useGameColorsProvider();

	return (
		<Flex
			justifyContent="center"
			w="100%"
			h="100%"
			backgroundColor={backgroundColor}
			backgroundSize="cover"
			backgroundRepeat="no-repeat"
			position="relative"
			_before={{
				content: "''",
				position: 'absolute',
				backgroundSize: '100% auto',
				backgroundRepeat: 'no-repeat',
				background: coverPhoto
					? isNonGradient
						? backgroundColor
						: `linear-gradient(180deg, ${callToActionColor} 0%, ${backgroundColor} 100%) 0% 0% / cover no-repeat`
					: isNonGradient
					? `${backgroundColor}40`
					: `linear-gradient(180deg, ${Color.BACKGROUND}6E 0%, ${color}6E 100%)`,
				opacity: coverPhoto ? '0.35' : '1',

				width: '100%',
				height: '100%',
				transition: 'opacity 2s cubic-bezier(0, 1.08, 0.15, 1.02)',
			}}
		>
			{children}
		</Flex>
	);
};
